import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiResponseModel,
  ApiVisa, Core2Config, GenericDocSearchCriteriaDtoModel, Pagination
} from 'blg-akaun-ts-lib';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PrintService {
  protected apiUrl: string;
  protected api_domain_url: string;
  protected endpoint_path: string;
  protected apiUrl2: string;
  protected endpoint_path2: string;

  protected httpClient: HttpClient;

  constructor(http: HttpClient,
  ) {
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "gen-doc";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "gen-doc/";
    this.httpClient = http;
    this.httpClient = http;
    this.apiUrl2 =
    Core2Config.DOMAIN_URL +
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.ERP_PREFIX +  Core2Config.FI_PREFIX +
    "cash-transfers";
    this.endpoint_path2 = Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.ERP_PREFIX +  Core2Config.FI_PREFIX +
    "cash-transfers";
  }

  public getApiUrl(apiVisa: ApiVisa) {
    let url = this.apiUrl;
    if (this.endpoint_path && apiVisa.api_domain_url) {
      url = apiVisa.api_domain_url + this.endpoint_path;
    }
    return url;
  }

  public getApiUrl2(apiVisa: ApiVisa) {
    let url = this.apiUrl2;
    if (this.endpoint_path2 && apiVisa.api_domain_url) {
      url = apiVisa.api_domain_url + this.endpoint_path2;
    }
    return url;
  }

  public getHttpHeaderBlob(apiVisa: ApiVisa, params?: HttpParams) {
    const httpOptions = {
      headers: new HttpHeaders({
        authorization: apiVisa.jwt_secret,
        responseType: 'blob',
        tenantCode: apiVisa.tenantCode
      }),
      params: params,
      responseType: 'blob' as 'json'
    };
    return httpOptions;
  }

  public printJasperPdf(
    docType: string,
    guid: string,
    printServiceClassName: string,
    printableFormatGuid: string,
    apiVisa: ApiVisa,
    customParam?: string,
  ): Observable<Blob> {
    let params;
    let url;

    if (customParam) {
      params = new HttpParams()
        .set('printServiceClassName', printServiceClassName)
        .set('printableFormatHdrGuid', printableFormatGuid)
        .set('customParam', customParam);
    } else {
      params = new HttpParams()
        .set('printServiceClassName', printServiceClassName)
        .set('printableFormatHdrGuid', printableFormatGuid);
    }
    url = apiVisa.api_domain_url + this.endpoint_path + docType+'/print-jasper-pdf/' + guid;
    return this.httpClient.get<Blob>(
      url,
      this.getHttpHeaderBlob(apiVisa, params)
    );
  }

  public batchPrintCashDocument(guids: any, printableFormatHdrGuid: any,apiVisa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    let body = {
      "guids":guids
    }
    url = apiVisa.api_domain_url +
    this.endpoint_path2 + "/batch-print-jasper-pdf/backoffice-ep?printableFormatHdrGuid="+printableFormatHdrGuid;

    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      body,
      this.getHttpHeaderBlob(apiVisa)
    );
  }

}
